import React from 'react';
import { connect } from 'react-redux';

// Selectors:
import {
  getLinkedCountryListTitle,
  getLinkedCountryListWithAnalytic,
} from '../../../../domain/state/linked/selectors';

// Components:
import { CountryListDesktop } from './CountryList.desktop';
import { CountryListMobile } from './CountryList.mobile';

// Models:
import type { ICountry } from './Models/country.model';

import { trackCountryListExpand, trackCountryListLinkClick } from './utils';

interface IOwnProps {
  className?: string;
  mapExpanded: boolean;
  isMobile: boolean;
  isMetaregion: boolean;
}

interface IStateProps {
  linkedCountryList: ICountry[];
  linkedCountryListTitle: string;
}

const mapStateToProps = (state) => ({
  linkedCountryList: getLinkedCountryListWithAnalytic(state),
  linkedCountryListTitle: getLinkedCountryListTitle(state),
});

export const CountryList = connect<IStateProps, TPseudoObject, IOwnProps>(
  mapStateToProps,
)((props: IOwnProps & IStateProps) => {
  const {
    linkedCountryList,
    linkedCountryListTitle,
    mapExpanded,
    isMobile,
    isMetaregion,
  } = props;

  if (!Array.isArray(linkedCountryList) || !linkedCountryList.length)
    return null;

  const countryListTitle = isMetaregion ? undefined : linkedCountryListTitle;
  const countryListPlacement = isMetaregion ? 'top' : 'bottom';

  const trackCountryListLinkClickEvent = (iso2: string) =>
    trackCountryListLinkClick(iso2, countryListPlacement);

  const trackCountryListExpandEvent = () =>
    trackCountryListExpand(countryListPlacement);

  return isMobile || mapExpanded ? (
    <CountryListMobile
      linkedCountryListTitle={countryListTitle}
      linkedCountryList={linkedCountryList}
      trackCountryLinkClick={trackCountryListLinkClickEvent}
      trackCountryListExpand={trackCountryListExpandEvent}
    />
  ) : (
    <CountryListDesktop
      linkedCountryListTitle={countryListTitle}
      linkedCountryList={linkedCountryList}
      trackCountryLinkClick={trackCountryListLinkClickEvent}
    />
  );
});
